<template>
  <div class="login">
    <div class="page-nav clearfix">
      <div class="common-block">
        <div class="page-nav-left clearfix" @click="$router.push('/')">
          <el-image class="nav-logo" :src="logoUrl"></el-image>
          <div class="nav-title">慈脉藏书阁</div>
        </div>
        <div class="page-nav-right clearfix">
          <!-- <div class="nav-free-use">免费使用</div>
          <div class="nav-login">登录</div> -->
        </div>
      </div>
    </div>
    <div class="content">
      <div class="pic"><img src="@/assets/images/login1.jpg" alt="" /></div>
      <div class="ms-login">
        <div class="k2">
          <el-tooltip
            class="box-item"
            effect="dark"
            :content="!isCodeLogin ? '扫码注册/登录' : '账号注册/登录'"
            placement="left"
          >
            <div @click="loginTypeChange" class="code-icon">
              <i v-if="isCodeLogin" class="iconfont icon-pc"></i>
              <i v-else class="iconfont icon-erweima"></i>
              <div class="bg"></div>
            </div>
          </el-tooltip>
          <template v-if="isCodeLogin">
            <codeToOpenid @bindSuccess="bindSuccess" />
          </template>
          <template v-else>
            <el-tabs
              v-model="activeName"
              class="demo-tabs"
              @tab-click="tabsChange"
            >
              <el-tab-pane label="手机号" name="1"></el-tab-pane>
              <el-tab-pane label="慈脉账号" name="2"></el-tab-pane>
            </el-tabs>
            <el-form
              class="ms-content"
              ref="formInline"
              :model="formInline"
              size="small"
              :rules="ruleInline"
            >
              <template v-if="activeName == '1'">
                <el-form-item prop="mobile">
                  <el-input
                    type="text"
                    v-model="formInline.mobile"
                    placeholder="请输入你的手机号"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item prop="verifyCode" class="code-item">
                  <el-input
                    type="text"
                    v-model="formInline.verifyCode"
                    placeholder="验证码"
                  >
                  </el-input>
                  <img @click="getVerifyCode" :src="codeUrl" alt="点击刷新" />
                </el-form-item>
                <el-form-item prop="validateCode" class="code-item">
                  <el-input
                    v-model="formInline.validateCode"
                    placeholder="请输入验证码"
                    @keyup.enter.native="handleSubmit"
                  >
                  </el-input>
                  <el-button type="text" size="small" @click="getCode">{{
                    btntext
                  }}</el-button>
                </el-form-item>
              </template>
              <template v-else>
                <el-form-item prop="user">
                  <el-input
                    type="text"
                    v-model="formInline.user"
                    placeholder="请输入你的慈脉账号"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input
                    type="password"
                    v-model="formInline.password"
                    placeholder="请输入密码"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item prop="verifyCode" class="code-item">
                  <el-input
                    @keyup.enter.native="handleSubmit"
                    type="text"
                    v-model="formInline.verifyCode"
                    placeholder="验证码"
                  >
                  </el-input>
                  <img @click="getVerifyCode" :src="codeUrl" alt="点击刷新" />
                </el-form-item>
              </template>
              <el-form-item class="btn">
                <el-button
                  :loading="loading"
                  type="danger"
                  @click="handleSubmit"
                  :disabled="!isDisabled"
                  round
                  >登录</el-button
                >
              </el-form-item>
              <div v-if="activeName == '1'" class="tip">
                未注册手机验证后自动登录
              </div>
            </el-form>
          </template>
        </div>
      </div>
    </div>
    <page-footer />
  </div>
</template>

<script>
import codeToOpenid from "@/components/codeToOpenid.vue";
import PageFooter from "@/components/pageFooter.vue";
import md5 from "js-md5";
export default {
  components: {
    codeToOpenid,
    PageFooter,
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      } else if (this.common.isPhone(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的手机号"));
      }
    };

    return {
      logoUrl: require("@/assets/images/logo5.png"),
      isCodeLogin: true,
      // isCodeLogin: false,
      btntext: "获取验证码",
      btnstate: false,

      activeName: "1",
      codeUrl: "",
      uuid: "",
      loading: false,
      formInline: {
        user: "",
        password: "",
        verifyCode: "",
        validateCode: "", //验证码
        mobile: "", //手机号
      },
      ruleInline: {
        user: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        verifyCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        mobile: [{ validator: checkPhone, required: true, trigger: "blur" }],
        validateCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    isDisabled() {
      return this.activeName == "1"
        ? this.formInline.mobile && this.formInline.validateCode
        : this.formInline.user &&
            this.formInline.password &&
            this.formInline.verifyCode;
    },
  },
  methods: {
    tabsChange() {
      // if (this.activeName == "2")
      this.getVerifyCode();
    },
    bindSuccess(unionId) {
      this.api("csgMiniLogin", { unionId }).then((res) => {
        this.$store.commit("employeeLogin", res.result);
      });
    },
    getCode() {
      if (this.btnstate) {
        return;
      }
      if (!this.formInline.mobile) {
        this.$message.warning("请输入手机号");
        return;
      } else if (!this.common.isPhone(this.formInline.mobile)) {
        this.$message.warning("手机号不正确");
        return;
      }
      if (!this.formInline.verifyCode) {
        this.$message.warning("请输入验证码");
        return;
      }
      this.$store.commit("showLoading");
      this.api("sendValidateCode", {
        mobile: this.formInline.mobile,
        verifyCode: this.formInline.verifyCode, //验证码
        verifyCodeImgId: this.uuid, // 	验证码图片Id
      })
        .then((res) => {
          this.$message.success(res.result);
          this.btnstate = true;
          let time = 60;
          let timer = setInterval(() => {
            time--;
            this.btntext = time + "s后重新获取";
            if (time == 0) {
              clearInterval(timer);
              this.btnstate = false;
              this.btntext = "获取验证码";
            }
          }, 1000);
          console.log(res);
        })
        .finally(() => {
          this.$store.commit("hideLoading");
          this.loading = false;
        });
    },

    loginTypeChange() {
      this.isCodeLogin = !this.isCodeLogin;
      if (!this.isCodeLogin) {
        this.getVerifyCode();
      }
    },

    getVerifyCode() {
      this.api("getVerifyCode", {
        sysCode: "jyd",
      }).then((res) => {
        this.codeUrl = "data:image/jpeg;base64," + res.result.img;
        this.uuid = res.result.uuid;
      });
    },
    handleSubmit() {
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store.commit("showLoading");
          if (this.activeName == "1") {
            this.api("csgMobileLogin", {
              mobile: this.formInline.mobile,
              validateCode: this.formInline.validateCode,
            })
              .then((res) => {
                this.$store.commit("employeeLogin", res.result);
              })
              .finally(() => {
                this.$store.commit("hideLoading");
                this.loading = false;
              });
          } else {
            this.api("employeeLogin", {
              account: this.formInline.user,
              passWord: md5(this.formInline.password),
              verifyCode: this.formInline.verifyCode, //验证码
              verifyCodeImgId: this.uuid, // 	验证码图片Id
            })
              .then((res) => {
                this.$store.commit("employeeLogin", res.result);
              })
              .catch(() => {
                this.getVerifyCode();
              })
              .finally(() => {
                this.$store.commit("hideLoading");
                this.loading = false;
              });
          }
        } else {
          this.$message.warning("请正确填写信息!");
        }
      });
    },
  },
  created() {
    localStorage.removeItem("fullPath2");
  },
};
</script>
<style lang="scss">
.login {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  // background: url("@/assets/images/bj1.jpg");
  background-size: 100% 100%;

  .btn {
    padding-top: 20px;

    .el-button {
      width: 100%;
    }
  }

  .el-tabs__nav-wrap::after {
    display: none;
  }
  .codebtn {
    cursor: pointer;
  }
}

.login .ms-login {
  position: relative;
  width: 350px;
  height: 400px;
}

.login .ms-login .k2 {
  height: 100%;
  background: #fff;
  padding: 40px 50px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  .code-icon {
    position: absolute;
    width: 50px;
    height: 50px;
    right: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    cursor: pointer;
    .bg {
      width: 200%;
      height: 200%;
      position: absolute;
      background: #d6555f;
      transform-origin: 110% 80%;
      transform: rotate(45deg);
      z-index: 1;
    }
    .iconfont {
      color: #fff;
      font-size: 26px;
      position: relative;
      z-index: 2;
      margin-left: 10px;
      margin-top: -10px;
    }
  }
  .tip {
    text-align: center;
    font-size: 12px;
    opacity: 0.6;
  }
}

.login .l_logo {
  margin: auto;
  width: 100px;
  height: 100px;
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
  position: absolute;
  left: 50%;
  top: -20px;
  margin-left: -50px;
  border-radius: 100%;
  overflow: hidden;
}

.login .l_logo img {
  width: 100%;
}

.login .ms-title {
  padding-top: 35px;
  width: 100%;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
  color: #e83d3c;
}

.login .btn {
  text-align: center;
}

.login {
  .page-nav {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 72px;
    z-index: 12;
    background-color: #fff;
    opacity: 0.7;
    font-family: PingFang-SC, PingFang-SC;

    .common-block {
      width: 1200px;
      margin: 0 auto;
    }

    &.not-carousel-field {
      opacity: 1;
      border-bottom: 1px solid #eee;
    }

    .page-nav-left {
      float: left;
      margin-top: 11px;
      cursor: pointer;

      .nav-logo {
        float: left;
        width: 50px;
      }

      .nav-title {
        float: left;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        line-height: 50px;
        letter-spacing: 4px;
        text-align: justify;
        font-style: normal;
        margin-left: 10px;
      }
    }

    .page-nav-right {
      float: right;

      .nav-login {
        float: right;
        font-weight: 400;
        font-size: 20px;
        color: #414141;
        line-height: 30px;
        cursor: pointer;
        margin-top: 10px;
        margin-right: 30px;
        padding: 10px;

        &:hover {
          color: #d7000f;
        }
      }

      .nav-free-use {
        float: right;
        font-size: 20px;
        color: #d7000f;
        line-height: 36px;
        border-radius: 27px;
        padding: 0 20px;
        border: 2px solid #d7000f;
        margin-top: 16px;
        cursor: pointer;

        &:hover {
          background: #d7000f;
          color: #fff;
        }
      }
    }
  }
  .content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .el-tabs__item.is-active {
    color: #000;
  }
  .el-tabs__active-bar {
    background: #d6555f;
  }
  .el-tabs {
    margin-bottom: 10px;
  }
  .el-input__inner {
    font-size: 14px;
  }
  .code-item {
    position: relative;
    .el-button {
      position: absolute;
      right: 15px;
      top: 0;
    }
    img {
      height: 29px;
      margin-left: 10px;
      cursor: pointer;
      position: absolute;
      right: 15px;
      top: 2px;
    }
  }
  .el-input__inner {
    border-radius: 16px;
  }
}
.dark {
  .login {
    background: #fff;
    color: #333;
  }
}
@media screen and (max-width: 600px) {
  .footer-container {
    .el-footer {
      .yw_bq {
        font-size: 10px !important;
      }
    }
  }
  .content {
    .pic {
      display: none;
    }
    .ms-login {
      margin: 5%;
      .k2 {
        padding: 20px;
        .ms-content {
          padding: 0 !important;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .login {
    .page-nav {
      width: 100%;
      height: 48px;

      .page-nav-left {
        margin-top: 6px;

        .nav-logo {
          width: 36px;
        }

        .nav-title {
          font-size: 20px;
          line-height: 36px;
          letter-spacing: 1px;
          margin-left: 6px;
        }
      }

      .page-nav-right {
        .nav-login {
          font-size: 16px;
          line-height: 30px;
          margin-top: 0;
          margin-right: 10px;
          padding: 8px;
        }

        .nav-free-use {
          font-size: 16px;
          line-height: 26px;
          border-radius: 25px;
          padding: 0 10px;
          border: 1px solid #d7000f;
          margin-top: 10px;
          margin-right: 10px;
        }
      }
    }
  }
  .common-block {
    width: 100%;
    margin: 0 auto;
  }
}
</style>
